import React, { useCallback } from "react";
import Button from "@streeteasy/design-system/deprecated/Button";
import { ErrorMessage, Formik } from "formik";
import { string } from "prop-types";

import { homeClaimPersonalInfoForm } from "../../schemas/homeClaimPersonalInfoForm";
import { useStore, useUserStoreData } from "../../utilities/mobx/storeHooks";
import * as S from "./styled";

const HomeClaimPersonalInfoForm = ({
  ariaContentDescribedBy,
  ariaContentLabelledBy,
  className
}) => {
  const { email, name, phoneNumber } = useUserStoreData();

  const { store } = useStore();
  const { personalInfoStore } = store;

  const handleFormSubmit = useCallback(
    (values, { setFieldError, setSubmitting }) => {
      personalInfoStore.handlePersonalInfoFormSubmit(values, {
        onFieldValidationError: fieldErrors => {
          fieldErrors.forEach(({ message, type }) => {
            setFieldError(type, message);
          });

          setSubmitting(false);
        },
        onComplete: () => setSubmitting(false)
      });
    },
    []
  );

  return (
    <S.Content className={className}>
      <S.FormTitle id={ariaContentLabelledBy}>
        Homeowner Information
      </S.FormTitle>
      <S.FormDescription id={ariaContentDescribedBy}>
        Please confirm your information.
      </S.FormDescription>
      <Formik
        initialValues={{ email, name, phoneNumber }}
        onSubmit={handleFormSubmit}
        validationSchema={homeClaimPersonalInfoForm}
      >
        {({
          errors,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <S.Label htmlFor="name">
              Name
              <S.FormTextInput
                id="name"
                name="name"
                onChange={(_, event) => {
                  handleChange(event);
                }}
                value={values.name}
              />
            </S.Label>
            <S.Label htmlFor="phoneNumber">
              Phone Number
              <S.FormTextInput
                id="phoneNumber"
                name="phoneNumber"
                onChange={(_, event) => {
                  handleChange(event);
                }}
                value={values.phoneNumber}
              />
            </S.Label>
            <S.Label htmlFor="email">
              Email
              <S.FormTextInput
                id="email"
                isInvalid={touched.email && !!errors.email}
                name="email"
                onChange={(_, event) => {
                  handleChange(event);
                }}
                value={values.email}
              />
              <ErrorMessage component={S.ErrorText} name="email" />
            </S.Label>
            <S.Spacer />
            <Button disabled={isSubmitting} theme="classicBlue" type="submit">
              Next
            </Button>
          </form>
        )}
      </Formik>
    </S.Content>
  );
};

HomeClaimPersonalInfoForm.propTypes = {
  ariaContentDescribedBy: string.isRequired,
  ariaContentLabelledBy: string.isRequired,
  className: string
};

HomeClaimPersonalInfoForm.defaultProps = {
  className: ""
};

export default HomeClaimPersonalInfoForm;
